const KEY = "buma.tenant";

/**
 * Der zuletzt gewählte Mandant. Nur eine Bequemlichkeit für diesen Browser — welcher
 * Mandant tatsächlich gilt, entscheidet der Server anhand der Mitgliedschaft.
 */
export function readSelectedTenant(storage: Storage | undefined = safeStorage()): string | null {
  try {
    return storage?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
}

export function writeSelectedTenant(
  slug: string | null,
  storage: Storage | undefined = safeStorage(),
): void {
  try {
    if (slug === null) {
      storage?.removeItem(KEY);
      return;
    }
    storage?.setItem(KEY, slug);
  } catch {
    // Privates Fenster oder gesperrter Speicher: die Auswahl gilt dann nur für diese Sitzung.
  }
}

function safeStorage(): Storage | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}
